(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sl-cost-of-inaction"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cost-comparison-calculator')) {
    class CostComparisonCalculator extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;
        this.inputs = Array.from(this.querySelectorAll('[data-cost-range]'));
        this.currentNightly = this.querySelector('[data-current-nightly]');
        this.currency = this.dataset.currency || 'AUD';
        this.currencyFormatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        this.wholeCurrencyFormatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        this.handleInput = this.update.bind(this);
        this.inputs.forEach((input) => input.addEventListener('input', this.handleInput));
        this.update();
      }

      disconnectedCallback() {
        this.inputs?.forEach((input) => input.removeEventListener('input', this.handleInput));
        this.isReady = false;
      }

      update() {
        const monthlyTotal = this.inputs.reduce((total, input) => {
          const value = Number(input.value);
          const minimum = Number(input.min);
          const maximum = Number(input.max);
          const progress = maximum === minimum ? 0 : ((value - minimum) / (maximum - minimum)) * 100;
          input.style.setProperty('--range-progress', `${progress}%`);
          input.setAttribute('aria-valuetext', `${this.wholeCurrencyFormatter.format(value)} per month`);
          const output = input.closest('.cost-comparison__control')?.querySelector('[data-cost-value]');
          if (output) output.textContent = this.wholeCurrencyFormatter.format(value);
          return total + value;
        }, 0);

        const nightlyTotal = (monthlyTotal * 12) / 365;
        if (this.currentNightly) this.currentNightly.textContent = this.currencyFormatter.format(nightlyTotal);
      }
    }

    customElements.define('cost-comparison-calculator', CostComparisonCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-editorial-split"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('cost-of-inaction')){
    class CostOfInaction extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;this.initialized=true;
        this.skincare=this.querySelector('[data-calculator-input="skincare"]');this.haircare=this.querySelector('[data-calculator-input="haircare"]');
        this.skincareOutput=this.querySelector('[data-skincare-output]');this.haircareOutput=this.querySelector('[data-haircare-output]');
        this.annualOutput=this.querySelector('[data-annual-total]');this.nightlyOutput=this.querySelector('[data-cost-per-night]');
        this.monthsOutput=this.querySelector('[data-comparison-months]');this.comparison=this.querySelector('[data-comparison]');
        this.zeroMessage=this.querySelector('[data-zero-message]');this.thread=this.querySelector('[data-thread]');
        this.basePrice=Number(this.dataset.basePrice)||229;this.duration=Number(this.dataset.duration)||300;this.currentAnnual=0;this.animationFrame=null;
        this.currencyWhole=new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',maximumFractionDigits:0});
        this.currencyDecimal=new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',minimumFractionDigits:2,maximumFractionDigits:2});
        this.onInput=this.update.bind(this);this.skincare.addEventListener('input',this.onInput);this.haircare.addEventListener('input',this.onInput);this.update(false);
      }
      disconnectedCallback(){if(!this.initialized)return;this.skincare.removeEventListener('input',this.onInput);this.haircare.removeEventListener('input',this.onInput);cancelAnimationFrame(this.animationFrame);this.initialized=false}
      update(animate=true){
        const skincare=Number(this.skincare.value),haircare=Number(this.haircare.value),annual=(skincare+haircare)*12;
        const maximumAnnual=(Number(this.skincare.max)+Number(this.haircare.max))*12,months=annual===0?0:Math.max(1,Math.round(annual/this.basePrice));
        this.skincareOutput.textContent=this.currencyWhole.format(skincare);this.haircareOutput.textContent=this.currencyWhole.format(haircare);
        this.skincare.setAttribute('aria-valuetext',`${this.currencyWhole.format(skincare)} per month`);this.haircare.setAttribute('aria-valuetext',`${this.currencyWhole.format(haircare)} per month`);
        this.setRangeProgress(this.skincare);this.setRangeProgress(this.haircare);this.nightlyOutput.textContent=this.currencyDecimal.format(annual/365);
        this.monthsOutput.textContent=`${months} ${months===1?'month':'months'}`;this.comparison.hidden=annual===0;this.zeroMessage.hidden=annual!==0;
        this.thread.style.setProperty('--thread-progress',`${Math.min(100,(annual/maximumAnnual)*100)}%`);this.animateAnnual(this.currentAnnual,annual,animate);this.currentAnnual=annual;
      }
      setRangeProgress(input){const progress=((Number(input.value)-Number(input.min))/(Number(input.max)-Number(input.min)))*100;input.style.setProperty('--range-progress',`${progress}%`)}
      animateAnnual(from,to,animate){
        cancelAnimationFrame(this.animationFrame);const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if(!animate||reduceMotion||from===to){this.annualOutput.textContent=this.currencyWhole.format(to);return}
        const start=performance.now(),step=now=>{const elapsed=Math.min(1,(now-start)/this.duration),eased=1-Math.pow(1-elapsed,3),value=Math.round(from+(to-from)*eased);this.annualOutput.textContent=this.currencyWhole.format(value);if(elapsed<1)this.animationFrame=requestAnimationFrame(step)};this.animationFrame=requestAnimationFrame(step);
      }
    }
    customElements.define('cost-of-inaction',CostOfInaction);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const visibilityThreshold = 0.25;
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector('[data-video-mount] video');

        if (!video) return;

        if (entry.isIntersecting && entry.intersectionRatio >= visibilityThreshold) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, {
      threshold: [0, visibilityThreshold, 1]
    });

    function mountVideos(root = document) {
      root.querySelectorAll('[data-responsive-hero-video]').forEach((card) => {
        const mount = card.querySelector('[data-video-mount]');
        const placeholder = card.querySelector('[data-video-placeholder]');
        const label = card.querySelector('[data-video-label]');
        const template = card.querySelector(mobileQuery.matches ? '[data-mobile-video]' : '[data-desktop-video]');

        if (!mount) return;
        const mode = mobileQuery.matches ? 'mobile' : 'desktop';
        if (mount.dataset.mode === mode) return;

        videoObserver.unobserve(card);
        mount.replaceChildren();
        mount.dataset.mode = mode;

        if (!template) {
          if (placeholder) placeholder.hidden = false;
          if (label) label.hidden = true;
          return;
        }

        mount.appendChild(template.content.cloneNode(true));
        if (placeholder) placeholder.hidden = true;
        if (label) label.hidden = false;
        const video = mount.querySelector('video');
        if (video) {
          video.defaultMuted = true;
          video.muted = true;
          video.autoplay = true;
          video.loop = true;
          video.playsInline = true;
          videoObserver.observe(card);
        }
      });
    }

    mountVideos();
    mobileQuery.addEventListener('change', () => mountVideos());
    document.addEventListener('shopify:section:load', (event) => mountVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-unboxing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const sectionStates = new WeakMap();

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = sectionStates.get(entry.target);
        if (!state) return;
        state.inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        syncPlayback(entry.target);
      });
    }, { threshold: [0, 0.2, 0.6] });

    function sectionList(root) {
      const sections = [];
      if (root.matches?.('[data-unboxing]')) sections.push(root);
      root.querySelectorAll?.('[data-unboxing]').forEach((section) => sections.push(section));
      return sections;
    }

    function updateDots(section, index) {
      const state = sectionStates.get(section);
      if (!state) return;
      state.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    }

    function syncPlayback(section) {
      const state = sectionStates.get(section);
      if (!state) return;

      state.cards.forEach((card, index) => {
        const video = card.querySelector('[data-video-mount] video');
        if (!video) return;
        const shouldPlay = state.inView && !card.dataset.userPaused && (!mobileQuery.matches || index === state.activeIndex);
        if (shouldPlay) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    function setActiveSlide(section, index, resetPrevious = false) {
      const state = sectionStates.get(section);
      if (!state) return;
      const nextIndex = Math.max(0, Math.min(index, state.cards.length - 1));

      if (resetPrevious && state.activeIndex !== nextIndex) {
        const previousVideo = state.cards[state.activeIndex]?.querySelector('[data-video-mount] video');
        if (previousVideo) previousVideo.currentTime = 0;
      }

      state.activeIndex = nextIndex;
      updateDots(section, nextIndex);
      syncPlayback(section);
    }

    function advanceCarousel(section, card) {
      const state = sectionStates.get(section);
      if (!state || !mobileQuery.matches || !state.inView) return;
      const currentIndex = state.cards.indexOf(card);
      if (currentIndex !== state.activeIndex) return;
      const nextIndex = (currentIndex + 1) % state.cards.length;
      const currentVideo = card.querySelector('[data-video-mount] video');
      if (currentVideo) currentVideo.currentTime = 0;
      setActiveSlide(section, nextIndex);
      state.grid.scrollTo({ left: state.cards[nextIndex].offsetLeft, behavior: 'smooth' });
    }

    function setupCarousel(section) {
      if (sectionStates.has(section)) return;
      const grid = section.querySelector('.sl-video-hero__grid');
      const cards = Array.from(section.querySelectorAll('[data-responsive-hero-video]'));
      const dots = Array.from(section.querySelectorAll('[data-unboxing-dot]'));
      if (!grid || !cards.length) return;

      const state = { grid, cards, dots, activeIndex: 0, inView: false, scrollFrame: null };
      sectionStates.set(section, state);
      sectionObserver.observe(section);

      grid.addEventListener('scroll', () => {
        if (!mobileQuery.matches || state.scrollFrame) return;
        state.scrollFrame = requestAnimationFrame(() => {
          state.scrollFrame = null;
          const width = grid.clientWidth || 1;
          const index = Math.round(grid.scrollLeft / width);
          setActiveSlide(section, index, true);
        });
      }, { passive: true });

      updateDots(section, 0);
    }

    function mountVideos(root = document) {
      sectionList(root).forEach((section) => {
        setupCarousel(section);

        section.querySelectorAll('[data-responsive-hero-video]').forEach((card) => {
          const mount = card.querySelector('[data-video-mount]');
          const placeholder = card.querySelector('[data-video-placeholder]');
          const label = card.querySelector('[data-video-label]');
          const toggle = card.querySelector('[data-video-toggle]');
          const template = card.querySelector(mobileQuery.matches ? '[data-mobile-video]' : '[data-desktop-video]');

          if (!mount) return;
          const mode = mobileQuery.matches ? 'mobile' : 'desktop';
          if (mount.dataset.mode === mode) return;

          mount.replaceChildren();
          mount.dataset.mode = mode;
          delete card.dataset.userPaused;

          if (!template) {
            if (toggle) toggle.hidden = true;
            if (placeholder) placeholder.hidden = false;
            if (label) label.hidden = true;
            return;
          }

          mount.appendChild(template.content.cloneNode(true));
          if (placeholder) placeholder.hidden = true;
          if (label) label.hidden = false;
          const video = mount.querySelector('video');

          if (toggle) {
            toggle.hidden = !video;
            toggle.dataset.state = 'playing';
            toggle.setAttribute('aria-label', 'Pause film');
            const toggleLabel = toggle.querySelector('[data-video-toggle-label]');
            if (toggleLabel) toggleLabel.textContent = 'Pause film';
            toggle.onclick = () => {
              if (!video) return;
              if (video.paused) {
                delete card.dataset.userPaused;
                video.play().catch(() => {});
                toggle.dataset.state = 'playing';
                toggle.setAttribute('aria-label', 'Pause film');
                if (toggleLabel) toggleLabel.textContent = 'Pause film';
              } else {
                card.dataset.userPaused = 'true';
                video.pause();
                toggle.dataset.state = 'paused';
                toggle.setAttribute('aria-label', 'Play film');
                if (toggleLabel) toggleLabel.textContent = 'Play film';
              }
            };
          }

          if (video) {
            video.defaultMuted = true;
            video.muted = true;
            video.autoplay = true;
            video.loop = !mobileQuery.matches;
            video.playsInline = true;
            video.addEventListener('ended', () => advanceCarousel(section, card));
          }
        });

        const state = sectionStates.get(section);
        if (state && mobileQuery.matches) {
          state.grid.scrollLeft = 0;
          setActiveSlide(section, 0);
        } else {
          syncPlayback(section);
        }
      });
    }

    mountVideos();
    mobileQuery.addEventListener('change', () => mountVideos());
    document.addEventListener('shopify:section:load', (event) => mountVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
